import React from 'react';
import './List.less';
import { ChevronRightIcon } from 'app/components/icons';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function ListItemButton({
  children,
  className,
  onClick,
}: Props) {
  return (
    <li
      className={clsx('base-list__item base-list__item-button', className)}
      onClick={onClick}
    >
      {children}

      <ChevronRightIcon />
    </li>
  );
}
